import { LanguageCode } from '@Hotels-at-Home/hah-fe-core/dist/constants';

export const POST_PATH = '/posts/[...path]';

export const LP_ARTICLE_NAME = '$landingPage';

export const COMMON_ARTICLE_NAME = '$article[id]';

// 0, 1, 2, ... - are the post ids
export const postData = {
  0: {
    urls: {
      [LanguageCode.En]: 'rituals-and-tips-for-exceptional-nights',
      [LanguageCode.De]: 'rituale-und-tipps-fur-auergewohnliche-nachte',
      [LanguageCode.Fr]: 'rituels-et-conseils-pour-des-nuits-dexception',
      [LanguageCode.Es]: 'rituales-y-consejos-para-noches-excepcionales',
    },
    heroImageUrl: '/images/blog/mercure-bed-bedding-set-LP-Hero-Crop',
    isLP: true,
  },
  1: {
    urls: {
      [LanguageCode.En]: 'bedtime-rituals-around-the-world',
      [LanguageCode.De]: 'einschlafrituale-aus-aller-welt',
      [LanguageCode.Fr]: 'les-differents-rituels-dendormissement-a-travers-le-monde',
      [LanguageCode.Es]: 'rituales-para-dormir-en-todo-el-mundo',
    },
    heroImageUrl: '/images/blog/hp-blog-mercure-article-1-banner',
    isLP: false,
  },
  2: {
    urls: {
      [LanguageCode.En]: 'the-different-types-of-naps-around-the-world-and-their-benefits',
      [LanguageCode.De]:
        'die-verschiedenen-arten-von-nickerchen-auf-der-ganzen-welt-und-ihre-vorteile',
      [LanguageCode.Fr]: 'les-differentes-types-de-siestes-a-travers-le-monde-et-ses-bienfaits',
      [LanguageCode.Es]: 'los-diferentes-tipos-de-siestas-en-el-mundo-y-sus-beneficios',
    },
    heroImageUrl: '/images/blog/hp-blog-mercure-article-2-banner',
    isLP: false,
  },
  3: {
    urls: {
      [LanguageCode.En]: 'how-to-wake-up-well-in-the-morning',
      [LanguageCode.De]: 'wie-man-morgens-gut-aufwacht',
      [LanguageCode.Fr]: 'comment-bien-se-reveiller-le-matin',
      [LanguageCode.Es]: 'como-despertarse-bien-por-la-manana',
    },
    heroImageUrl: '/images/blog/hp-blog-mercure-article-3-banner',
    isLP: false,
  },
  4: {
    urls: {
      [LanguageCode.En]: 'sleeping-on-a-made-in-france-mattress',
      [LanguageCode.De]: 'schlafen-auf-einer-made-in-france-matratze',
      [LanguageCode.Fr]: 'dormir-sur-un-lit-made-in-france',
      [LanguageCode.Es]: 'dormir-en-un-colchon-fabricado-en-francia',
    },
    heroImageUrl: '/images/blog/hp-blog-mercure-article-4-banner',
    isLP: false,
  },
};

// Use for multi-language url detection
export const postList = Object.keys(postData).reduce((acc, val) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { isLP } = postData[val];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const urls = Object.entries(postData[val].urls) || [];

  urls.forEach(item => {
    acc.push({
      id: Number(val),
      locale: item[0],
      url: item[1],
      isLP,
    });
  });

  return acc;
}, []);
